/* cart-page-2026.js — Cart page redesign 2026 (ENG-7579, now the default — A/B removed).

   Line items + upsell AJAX, ISOLATED from cart.js (which hardcodes the
   'main-cart' section and the legacy selectors → can't be touched). Re-render via
   the Section Rendering API against section_id=main-cart-2026. The 2026 design is
   the default /cart template now (A/B removed, ENG-7579), so we render against
   plain /cart — no ?view= needed.

   - <cart-items-2026>: qty +/− and remove (POST /cart/change.js).
   - Document-level delegation: upsell "Add" (POST /cart/add.js) + carousel
     arrows. The carousel is injected by the global <product-recommendations>
     (assets/global.js); its innerHTML is preserved across re-renders (mirroring
     what cart.js does to avoid losing the recommendations).

   Only runs on the 2026 page (the custom element/classes only exist there). */
(function () {
  'use strict';

  var SECTION_ID = 'main-cart-2026';

  function cartChangeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  }
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }
  // Render the section against the default /cart template, which now serves the 2026
  // design (A/B removed, ENG-7579) — no ?view= override needed.
  function sectionsUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }
  function postConfig(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    };
  }

  function setLoading(on) {
    var page = document.getElementById('main-cart-2026');
    if (page) page.classList.toggle('cart-2026-loading', !!on);
  }

  // Replace the entire section with the re-rendered HTML. Covers items,
  // transition to empty state, summary (Phase 9) and the counter. Preserves the
  // already-loaded upsell so it isn't lost on each re-render.
  function renderSection(state) {
    var html = state && state.sections && state.sections[SECTION_ID];
    var current = document.getElementById('main-cart-2026');
    if (!html || !current) {
      setLoading(false);
      return;
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('main-cart-2026');
    if (!fresh) {
      setLoading(false);
      return;
    }

    // Recommendations are seeded from cart.items.last.product_id (data-url). The fresh section
    // placeholder comes empty and <product-recommendations> does NOT re-fetch on a dynamic swap
    // (its connectedCallback only binds DOMContentLoaded / shopify:section:load — neither fires on
    // a Sections-API re-render). So:
    //  - seed UNCHANGED (e.g. quantity change): copy the loaded cards over to avoid a fetch/flash.
    //  - seed CHANGED (e.g. the last item was removed): do NOT copy stale cards; trigger a fresh
    //    fetch after the swap so the carousel reflects the new seed product (handled below).
    var oldRec = current.querySelector('product-recommendations');
    var newRec = fresh.querySelector('product-recommendations');
    var seedUnchanged = oldRec && newRec &&
      oldRec.getAttribute('data-url') === newRec.getAttribute('data-url');
    if (seedUnchanged && oldRec.innerHTML.trim().length) {
      newRec.innerHTML = oldRec.innerHTML;
    }

    // Counter for the header bubble (read from the fresh DOM, not the payload).
    var countNode = fresh.querySelector('.cart-2026-count');
    var count = null;
    if (countNode) {
      var m = (countNode.textContent || '').match(/\d+/);
      if (m) count = parseInt(m[0], 10);
    }

    current.replaceWith(fresh);
    // Seed changed → the swapped-in node won't auto-fetch (see above), so kick it manually now that
    // it's connected/upgraded, to pull recommendations for the new seed instead of leaving it empty.
    if (!seedUnchanged && newRec && typeof newRec.fetchProductRecommendations === 'function') {
      newRec.fetchProductRecommendations();
    }
    if (count !== null && !isNaN(count)) updateCartBubble(count);
  }

  function updateCartBubble(count) {
    var host = document.getElementById('cart-icon-bubble');
    if (!host) return;
    var bubble = host.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (bubble) {
        var n = bubble.querySelector('[aria-hidden="true"]');
        if (n && count < 100) n.textContent = count;
      }
    } else if (bubble) {
      bubble.remove();
    }
  }

  function showError(line, message) {
    var text = message || (window.cartStrings && window.cartStrings.error) || 'Could not update cart.';
    if (line != null) {
      var box = document.getElementById('CartItem2026-error-' + line);
      if (box) box.textContent = text;
    }
    var live = document.getElementById('cart-2026-live-region');
    if (live) live.textContent = text;
  }

  // ── Custom element: line items (qty / remove) ──
  function CartItems2026() {
    return Reflect.construct(HTMLElement, [], CartItems2026);
  }
  CartItems2026.prototype = Object.create(HTMLElement.prototype);
  CartItems2026.prototype.constructor = CartItems2026;

  CartItems2026.prototype.connectedCallback = function () {
    if (this._wired) return;
    this._wired = true;
    this.addEventListener('click', this.onClick.bind(this));
  };

  CartItems2026.prototype.onClick = function (event) {
    var btn = event.target.closest('.cart-2026-qty-btn, .cart-2026-remove');
    if (!btn || !this.contains(btn)) return;

    var item = btn.closest('.cart-2026-item');
    if (!item) return;

    var line = parseInt(item.getAttribute('data-line'), 10);
    var current = parseInt(item.getAttribute('data-quantity'), 10) || 1;

    var newQty;
    if (btn.classList.contains('cart-2026-remove')) {
      newQty = 0;
    } else {
      newQty = btn.getAttribute('data-action') === 'plus' ? current + 1 : current - 1;
      if (newQty < 0) newQty = 0;
    }
    if (newQty === current) return;

    changeQuantity(line, newQty);
  };

  function changeQuantity(line, quantity) {
    setLoading(true);
    var box = document.getElementById('CartItem2026-error-' + line);
    if (box) box.textContent = '';

    var body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: SECTION_ID,
      sections_url: sectionsUrl()
    });

    fetch(cartChangeUrl(), postConfig(body))
      .then(function (r) {
        return r.json().then(function (state) {
          return { ok: r.ok, state: state };
        });
      })
      .then(function (res) {
        if (!res.ok || res.state.status) {
          showError(line, res.state.description || res.state.message || '');
          setLoading(false);
          return;
        }
        renderSection(res.state);
      })
      .catch(function () {
        showError(line, '');
        setLoading(false);
      });
  }

  if (!customElements.get('cart-items-2026')) {
    customElements.define('cart-items-2026', CartItems2026);
  }

  // ── Upsell: Add to cart + carousel arrows (delegated to document, because
  //    the carousel is injected dynamically by <product-recommendations>) ──
  function addToCart(btn) {
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    setLoading(true);

    var body = JSON.stringify({
      items: [{ id: id, quantity: 1 }],
      sections: SECTION_ID,
      sections_url: sectionsUrl()
    });

    fetch(cartAddUrl(), postConfig(body))
      .then(function (r) {
        return r.json().then(function (state) {
          return { ok: r.ok, state: state };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          showError(null, res.state.description || res.state.message || '');
          setLoading(false);
          return;
        }
        renderSection(res.state);
      })
      .catch(function () {
        showError(null, '');
        setLoading(false);
      });
  }

  function scrollTrackFor(btn) {
    var upsell = btn.closest('.cart-2026-upsell');
    return upsell ? upsell.querySelector('.cart-2026-scroll-track') : null;
  }

  function scrollAmount(track) {
    var card = track.querySelector('.cart-2026-upsell-card');
    return card ? card.offsetWidth + 12 : 212;
  }

  function updateArrows(track) {
    var upsell = track.closest('.cart-2026-upsell');
    if (!upsell) return;
    var prev = upsell.querySelector('[data-scroll="prev"]');
    var next = upsell.querySelector('[data-scroll="next"]');
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }

  // ── Promo code (works via POST /cart/update.js { discount }) ──
  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  // Did the code take? The response (always 200) carries discount_codes with `applicable`
  // when present; otherwise we fall back to checking for cart-level discounts.
  function promoApplied(state, code) {
    var cc = (code || '').toUpperCase();
    var codes = state.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if ((codes[i].code || '').toUpperCase() === cc) return !!codes[i].applicable;
    }
    return (state.cart_level_discount_applications || []).length > 0;
  }

  // The re-render replaces the node (resets the promo to server state, collapsed and with
  // no message), so we re-apply the promo state onto the fresh DOM.
  function showPromoResult(code, applied) {
    var promo = document.querySelector('.cart-2026-promo');
    if (!promo) return;
    promo.classList.add('cart-2026-promo-open');
    var toggle = promo.querySelector('.cart-2026-promo-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var input = promo.querySelector('.cart-2026-promo-input');
    if (input) input.value = code;
    var msg = promo.querySelector('.cart-2026-promo-msg');
    if (msg) {
      if (applied) {
        msg.textContent = '✓ ' + code.toUpperCase() + ' applied';
        msg.className = 'cart-2026-promo-msg is-applied';
      } else {
        msg.textContent = 'Invalid or expired code';
        msg.className = 'cart-2026-promo-msg is-error';
      }
    }
  }

  // In-flight guard: double-clicking "Apply" or mashing Enter would otherwise fire concurrent
  // POST /cart/update.js requests that race and can leave the cart inconsistent. Ignore re-entry
  // until the current apply resolves.
  var promoInFlight = false;
  function applyPromo(code) {
    code = (code || '').trim();
    if (!code) return;
    if (promoInFlight) return;
    promoInFlight = true;
    setLoading(true);

    var body = JSON.stringify({
      discount: code,
      sections: SECTION_ID,
      sections_url: sectionsUrl()
    });

    fetch(cartUpdateUrl(), postConfig(body))
      .then(function (r) {
        return r.json().then(function (state) {
          return { ok: r.ok, state: state };
        });
      })
      .then(function (res) {
        var applied = res.ok && promoApplied(res.state, code);
        // The cart may have changed (discount applied/cleared) → re-render totals.
        if (res.state && res.state.sections) {
          renderSection(res.state);
        } else {
          setLoading(false);
        }
        showPromoResult(code, applied);
      })
      .catch(function () {
        setLoading(false);
        showPromoResult(code, false);
      })
      .then(function () { promoInFlight = false; });
  }

  document.addEventListener('click', function (event) {
    var scrollBtn = event.target.closest('.cart-2026-scroll-btn');
    if (scrollBtn) {
      var track = scrollTrackFor(scrollBtn);
      if (track) {
        var dir = scrollBtn.getAttribute('data-scroll') === 'prev' ? -1 : 1;
        track.scrollBy({ left: dir * scrollAmount(track), behavior: 'smooth' });
      }
      return;
    }
    var addBtn = event.target.closest('.cart-2026-upsell-add');
    if (addBtn && !addBtn.disabled && addBtn.getAttribute('data-variant-id')) {
      addToCart(addBtn);
      return;
    }
    var promoToggle = event.target.closest('.cart-2026-promo-toggle');
    if (promoToggle) {
      var promo = promoToggle.closest('.cart-2026-promo');
      if (promo) {
        var open = promo.classList.toggle('cart-2026-promo-open');
        promoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var inp = promo.querySelector('.cart-2026-promo-input');
          if (inp) inp.focus();
        }
      }
      return;
    }
    var promoApply = event.target.closest('.cart-2026-promo-apply');
    if (promoApply) {
      var wrap = promoApply.closest('.cart-2026-promo');
      var field = wrap && wrap.querySelector('.cart-2026-promo-input');
      if (field) applyPromo(field.value);
    }
  });

  // Enter in the promo input: apply, do NOT submit the cart form (checkout).
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var field = event.target.closest('.cart-2026-promo-input');
    if (!field) return;
    event.preventDefault();
    applyPromo(field.value);
  });

  // scroll doesn't bubble → capture on document to update the arrow state.
  document.addEventListener(
    'scroll',
    function (event) {
      var t = event.target;
      if (t && t.classList && t.classList.contains('cart-2026-scroll-track')) {
        updateArrows(t);
      }
    },
    true
  );
})();
